(function (global) {
    var STORAGE_KEY = 'marketplaceDisplayCurrency';
    var ALLOWED = ['USD', 'UGX', 'KES', 'GBP'];

    function normalise(code) {
        if (!code || typeof code !== 'string') {
            return null;
        }
        var c = code.trim().toUpperCase();
        return ALLOWED.indexOf(c) >= 0 ? c : null;
    }

    function getDisplayCurrency() {
        try {
            var params = new URLSearchParams(window.location.search);
            var q = normalise(params.get('display_currency'));
            if (q) {
                return q;
            }
        } catch (e) {}

        try {
            var s = normalise(localStorage.getItem(STORAGE_KEY));
            if (s) {
                return s;
            }
        } catch (e2) {}

        return null;
    }

    function setDisplayCurrency(code) {
        var c = normalise(code);
        if (!c) {
            try {
                localStorage.removeItem(STORAGE_KEY);
            } catch (e) {}
            return;
        }
        try {
            localStorage.setItem(STORAGE_KEY, c);
        } catch (e2) {}
    }

    global.getMarketplaceDisplayCurrency = getDisplayCurrency;
    global.setMarketplaceDisplayCurrency = setDisplayCurrency;
    global.MARKETPLACE_DISPLAY_CURRENCIES = ALLOWED.slice();
})(typeof window !== 'undefined' ? window : this);